var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "BoxWrap",
        { attrs: { title: _vm.$t("route.mixmore") } },
        [
          _c("HeaderFilter", {
            attrs: { labels: _vm.headerLabers },
            model: {
              value: _vm.salesForm,
              callback: function ($$v) {
                _vm.salesForm = $$v
              },
              expression: "salesForm",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "BoxWrap",
        { attrs: { "no-title": "" } },
        [
          _c(
            "el-row",
            { attrs: { gutter: 10 } },
            [
              _c("el-col", { attrs: { span: 9 } }, [
                _c(
                  "div",
                  { staticClass: "light-blue-board" },
                  [
                    _c(
                      "el-tabs",
                      {
                        model: {
                          value: _vm.mixActiveTab,
                          callback: function ($$v) {
                            _vm.mixActiveTab = $$v
                          },
                          expression: "mixActiveTab",
                        },
                      },
                      [
                        _c("el-tab-pane", {
                          attrs: { label: "18+", name: "18" },
                        }),
                        _vm._v(" "),
                        _c("el-tab-pane", {
                          attrs: { label: "19+", name: "19" },
                        }),
                        _vm._v(" "),
                        _c("el-tab-pane", {
                          attrs: { label: "20+", name: "20" },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "display-text-detail" },
                      [
                        _c("p", { staticClass: "title" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t("sfe.reportModule.table.acturlSales")
                            ) + " / AOP"
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", [
                          _c("span", { staticClass: "active-number" }, [
                            _vm._v(
                              _vm._s(
                                _vm.paddingNum(_vm.mixActiveTabData.actualCount)
                              )
                            ),
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "number" }, [
                            _vm._v(
                              "/" +
                                _vm._s(
                                  _vm.paddingNum(_vm.mixActiveTabData.aopCount)
                                )
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c(
                          "el-row",
                          { staticClass: "mt_20" },
                          [
                            _c("el-col", { attrs: { span: 12 } }, [
                              _c("p", { staticClass: "title" }, [
                                _vm._v(
                                  _vm._s(_vm.$t("dashboard.achievementRate"))
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", [
                                _c("span", { staticClass: "num1" }, [
                                  _vm._v(
                                    _vm._s(
                                      parseFloat(
                                        _vm.mixActiveTabData.aopCount
                                      ) === 0
                                        ? "-"
                                        : _vm.paddingNum(
                                            _vm.mixActiveTabData.finishRate
                                          )
                                    )
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("span", { staticClass: "num2" }, [
                                  _vm._v("%"),
                                ]),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("el-col", { attrs: { span: 12 } }, [
                              _c("p", { staticClass: "title" }, [
                                _vm._v(
                                  _vm._s(_vm.$t("dashboard.underachievedQuat"))
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", [
                                _c("span", { staticClass: "num1" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.paddingNum(
                                        _vm.mixActiveTabData.gapCount
                                      )
                                    )
                                  ),
                                ]),
                              ]),
                            ]),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c("el-col", { attrs: { span: 15 } }, [
                _c("div", {
                  staticClass: "echarts300",
                  attrs: { id: "id_mixLineEchart" },
                }),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-tabs",
            {
              staticClass: "main-table-container",
              on: {
                "tab-click": function (e) {
                  return _vm.fetchTablePageOne(e.name)
                },
              },
              model: {
                value: _vm.activeTab,
                callback: function ($$v) {
                  _vm.activeTab = $$v
                },
                expression: "activeTab",
              },
            },
            [
              _c(
                "el-tab-pane",
                {
                  attrs: {
                    label: _vm.$t("dashboard.spSort"),
                    name: "3",
                    lazy: "",
                  },
                },
                [
                  _c(
                    "el-table",
                    {
                      directives: [
                        {
                          name: "loading",
                          rawName: "v-loading",
                          value: _vm.sp_table.loading,
                          expression: "sp_table.loading",
                        },
                      ],
                      ref: "spMultipleTable",
                      staticStyle: { width: "100%" },
                      attrs: {
                        data: _vm.sp_table.data,
                        "highlight-current-row": "",
                        "tooltip-effect": "dark",
                        "default-sort": _vm.sp_table.defaultSort,
                      },
                      on: {
                        "selection-change": function (val) {
                          return _vm.selectionChange(val, "sp_table")
                        },
                        "sort-change": _vm.sortSpTable,
                      },
                    },
                    [
                      _c("el-table-column", {
                        attrs: { type: "selection", width: "55" },
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "rowNumber",
                          label: _vm.$t("dashboard.sortNum"),
                        },
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "spName",
                          label: _vm.$t("dashboard.spName"),
                          sortable: "custom",
                        },
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "mixRate",
                          label: _vm.$t("dashboard.mix"),
                          sortable: "custom",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      scope.row.mixRate == undefined
                                        ? "-"
                                        : _vm.paddingNum(scope.row.mixRate) +
                                            "%"
                                    ) +
                                    "\n            "
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "actualCount",
                          label: _vm.$t("dashboard.salesNumber"),
                          sortable: "custom",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.paddingNum(scope.row.actualCount)
                                    )
                                  ),
                                ]),
                              ]
                            },
                          },
                        ]),
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { label: _vm.$t("common.comment") },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c("el-button", {
                                  attrs: {
                                    size: "mini",
                                    icon: "el-icon-chat-dot-square",
                                    type: "primary",
                                    plain: "",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.addCommentByRow(
                                        scope.row,
                                        "spSapId",
                                        "spId"
                                      )
                                    },
                                  },
                                }),
                              ]
                            },
                          },
                        ]),
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "mt_20" },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { disabled: !_vm.sp_table.selected.length },
                          on: {
                            click: function ($event) {
                              return _vm.addCommentByBatch("sp_table", "spName")
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.$t("common.comment")))]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("pagination", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.sp_table.total > 0,
                        expression: "sp_table.total>0",
                      },
                    ],
                    attrs: {
                      total: _vm.sp_table.total,
                      page: _vm.sp_table.currPage,
                      limit: _vm.sp_table.limit,
                    },
                    on: {
                      "update:page": function ($event) {
                        return _vm.$set(_vm.sp_table, "currPage", $event)
                      },
                      "update:limit": function ($event) {
                        return _vm.$set(_vm.sp_table, "limit", $event)
                      },
                      pagination: _vm.fetchSpList,
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _vm.isShowASMTable
                ? _c(
                    "el-tab-pane",
                    {
                      attrs: {
                        label: _vm.$t("dashboard.asrSort"),
                        name: "1",
                        lazy: "",
                      },
                    },
                    [
                      _c(
                        "el-table",
                        {
                          directives: [
                            {
                              name: "loading",
                              rawName: "v-loading",
                              value: _vm.asm_table.loading,
                              expression: "asm_table.loading",
                            },
                          ],
                          ref: "asmMultipleTable",
                          staticStyle: { width: "100%" },
                          attrs: {
                            data: _vm.asm_table.data,
                            "highlight-current-row": "",
                            "tooltip-effect": "dark",
                            "default-sort": _vm.asm_table.defaultSort,
                          },
                          on: {
                            "selection-change": function (val) {
                              return _vm.selectionChange(val, "asm_table")
                            },
                            "sort-change": _vm.sortAsmTable,
                          },
                        },
                        [
                          _c("el-table-column", {
                            attrs: { type: "selection", width: "55" },
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              prop: "rowNumber",
                              label: _vm.$t("dashboard.sortNum"),
                            },
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              prop: "asmEmpNoName",
                              label: _vm.$t("dashboard.filter.asm"),
                              sortable: "custom",
                            },
                          }),
                          _vm._v(" "),
                          _vm.mixActiveTab === "18"
                            ? _c("el-table-column", {
                                attrs: {
                                  prop: "finishRate",
                                  label: _vm.$t("sfe.srDetail.radio"),
                                  sortable: "custom",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (scope) {
                                        return [
                                          _c(
                                            "span",
                                            {
                                              class:
                                                scope.row.finishRate > 100
                                                  ? "table_text_blue"
                                                  : "",
                                            },
                                            [
                                              _vm._v(
                                                "\n                " +
                                                  _vm._s(
                                                    parseFloat(
                                                      scope.row.aopCount
                                                    ) === 0
                                                      ? "-"
                                                      : _vm.paddingNum(
                                                          scope.row.finishRate
                                                        )
                                                  ) +
                                                  "%\n              "
                                              ),
                                            ]
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  901102480
                                ),
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              prop: "actualCount",
                              label: _vm.$t("dashboard.salesNumber"),
                              sortable: "custom",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _c(
                                        "span",
                                        {
                                          class:
                                            scope.row.finishRate > 100
                                              ? "table_text_blue"
                                              : "",
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.paddingNum(
                                                scope.row.actualCount
                                              )
                                            )
                                          ),
                                        ]
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              504898069
                            ),
                          }),
                          _vm._v(" "),
                          _vm.mixActiveTab === "18"
                            ? _c("el-table-column", {
                                attrs: {
                                  prop: "aopCount",
                                  label: "AOP",
                                  sortable: "custom",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (scope) {
                                        return [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.paddingNum(
                                                  scope.row.aopCount
                                                )
                                              )
                                            ),
                                          ]),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  3555948221
                                ),
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.mixActiveTab === "18"
                            ? _c("el-table-column", {
                                attrs: {
                                  prop: "unFinishCount",
                                  label: _vm.$t("dashboard.underachievedQuat"),
                                  sortable: "custom",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (scope) {
                                        return [
                                          _c(
                                            "span",
                                            {
                                              class:
                                                scope.row.finishRate > 100
                                                  ? "table_text_blue"
                                                  : "",
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.paddingNum(
                                                    scope.row.unFinishCount
                                                  )
                                                )
                                              ),
                                            ]
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  3166557683
                                ),
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: { label: _vm.$t("common.comment") },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _c("el-button", {
                                        attrs: {
                                          size: "mini",
                                          icon: "el-icon-chat-dot-square",
                                          type: "primary",
                                          plain: "",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.addCommentByRow(
                                              scope.row,
                                              "smEmpNo",
                                              "asmEmpNo"
                                            )
                                          },
                                        },
                                      }),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              2130886467
                            ),
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "mt_20" },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: {
                                disabled: !_vm.asm_table.selected.length,
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.addCommentByBatch(
                                    "asm_table",
                                    "asmEmpNoName"
                                  )
                                },
                              },
                            },
                            [_vm._v(_vm._s(_vm.$t("common.comment")))]
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("pagination", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.asm_table.total > 0,
                            expression: "asm_table.total>0",
                          },
                        ],
                        attrs: {
                          total: _vm.asm_table.total,
                          page: _vm.asm_table.currPage,
                          limit: _vm.asm_table.limit,
                        },
                        on: {
                          "update:page": function ($event) {
                            return _vm.$set(_vm.asm_table, "currPage", $event)
                          },
                          "update:limit": function ($event) {
                            return _vm.$set(_vm.asm_table, "limit", $event)
                          },
                          pagination: _vm.fetchAsmList,
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "el-tab-pane",
                {
                  attrs: {
                    label: _vm.$t("dashboard.srSort"),
                    name: "2",
                    lazy: "",
                  },
                },
                [
                  _c(
                    "el-table",
                    {
                      directives: [
                        {
                          name: "loading",
                          rawName: "v-loading",
                          value: _vm.sr_table.loading,
                          expression: "sr_table.loading",
                        },
                      ],
                      ref: "srMultipleTable",
                      staticStyle: { width: "100%" },
                      attrs: {
                        data: _vm.sr_table.data,
                        "highlight-current-row": "",
                        "tooltip-effect": "dark",
                        "default-sort": _vm.sr_table.defaultSort,
                      },
                      on: {
                        "selection-change": function (val) {
                          return _vm.selectionChange(val, "sr_table")
                        },
                        "sort-change": _vm.sortSrTable,
                      },
                    },
                    [
                      _c("el-table-column", {
                        attrs: { type: "selection", width: "55" },
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "rowNumber",
                          label: _vm.$t("dashboard.sortNum"),
                        },
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "srEmpNoName",
                          label: _vm.$t("dashboard.filter.sr"),
                          sortable: "custom",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c(
                                  "span",
                                  {
                                    staticClass: "pointer",
                                    on: {
                                      click: function ($event) {
                                        return _vm.toSrDetailsPage(scope.row)
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(scope.row.srEmpNoName) +
                                        "\n              "
                                    ),
                                  ]
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                      _vm._v(" "),
                      _vm.mixActiveTab === "18"
                        ? _c("el-table-column", {
                            attrs: {
                              prop: "finishRate",
                              label: _vm.$t("sfe.srDetail.radio"),
                              sortable: "custom",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _c(
                                        "span",
                                        {
                                          class:
                                            scope.row.finishRate > 100
                                              ? "table_text_blue"
                                              : "",
                                        },
                                        [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(
                                                parseFloat(
                                                  scope.row.aopCount
                                                ) === 0
                                                  ? "-"
                                                  : _vm.paddingNum(
                                                      scope.row.finishRate
                                                    )
                                              ) +
                                              "%\n              "
                                          ),
                                        ]
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              901102480
                            ),
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "actualCount",
                          label: _vm.$t("dashboard.salesNumber"),
                          sortable: "custom",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c(
                                  "span",
                                  {
                                    class:
                                      scope.row.finishRate > 100
                                        ? "table_text_blue"
                                        : "",
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.paddingNum(scope.row.actualCount)
                                      )
                                    ),
                                  ]
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                      _vm._v(" "),
                      _vm.mixActiveTab === "18"
                        ? _c("el-table-column", {
                            attrs: {
                              prop: "aopCount",
                              label: "AOP",
                              sortable: "custom",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.paddingNum(scope.row.aopCount)
                                          )
                                        ),
                                      ]),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              3555948221
                            ),
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.mixActiveTab === "18"
                        ? _c("el-table-column", {
                            attrs: {
                              prop: "unFinishCount",
                              label: _vm.$t("dashboard.underachievedQuat"),
                              sortable: "custom",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _c(
                                        "span",
                                        {
                                          class:
                                            scope.row.finishRate > 100
                                              ? "table_text_blue"
                                              : "",
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.paddingNum(
                                                scope.row.unFinishCount
                                              )
                                            )
                                          ),
                                        ]
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              3166557683
                            ),
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { label: _vm.$t("common.comment") },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c("el-button", {
                                  attrs: {
                                    size: "mini",
                                    icon: "el-icon-chat-dot-square",
                                    type: "primary",
                                    plain: "",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.addCommentByRow(
                                        scope.row,
                                        "srEmpNo",
                                        "srEmpNo"
                                      )
                                    },
                                  },
                                }),
                                _vm._v(" "),
                                _c("el-button", {
                                  attrs: {
                                    type: "primary",
                                    size: "mini",
                                    icon: "el-icon-notebook-2",
                                    plain: "",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.assignTasks(scope.row)
                                    },
                                  },
                                }),
                              ]
                            },
                          },
                        ]),
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "mt_20" },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { disabled: !_vm.sr_table.selected.length },
                          on: {
                            click: function ($event) {
                              return _vm.addCommentByBatch(
                                "sr_table",
                                "srEmpNoName"
                              )
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.$t("common.comment")))]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("pagination", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.sr_table.total > 0,
                        expression: "sr_table.total>0",
                      },
                    ],
                    attrs: {
                      total: _vm.sr_table.total,
                      page: _vm.sr_table.currPage,
                      limit: _vm.sr_table.limit,
                    },
                    on: {
                      "update:page": function ($event) {
                        return _vm.$set(_vm.sr_table, "currPage", $event)
                      },
                      "update:limit": function ($event) {
                        return _vm.$set(_vm.sr_table, "limit", $event)
                      },
                      pagination: _vm.fetchSrList,
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.showCommentDialog
        ? _c("Commment", {
            attrs: {
              visible: _vm.showCommentDialog,
              "current-row": _vm.currentRow,
            },
            on: {
              submit: _vm.submitCommentDialog,
              close: _vm.closeCommentDialog,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _c("AssignTasks", { ref: "AssignTasks" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }